import { render } from "./MyCentre.vue?vue&type=template&id=f9fefb9a"
import script from "./MyCentre.vue?vue&type=script&lang=js"
export * from "./MyCentre.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6558ed2e51dee85cd0a9e429c286fa8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__